import { CheckboxState } from '../types/agreements.types';

export const findUpdatedSteps = (initialSteps: CheckboxState, newSteps: CheckboxState) => {
	return Object.keys(initialSteps).filter((key) =>
		initialSteps[key].some((value, index) => value === false && newSteps[key][index] === true),
	);
};
